/**
 * Basic email validation checking for `@` followed by `.` in the string
 * @param {string} param
 * @returns {boolean}
 */
export const isEmail = (param: string) => {
  const regex = /(@)(.+)([.])(.+)$/;
  return regex.test(param);
};
